module.exports = __webpack_public_path__ + "img/2.430bf4e7.jpg";